export default {
  async searchOrder(params) {
    console.warn('calling VTEX search!')
    return [];
  }
}


// WEBPACK FOOTER //
// /src/services/vtex.js